import { Button, Flex, Icon } from '@chakra-ui/react';
import React from 'react';

import { IconTrashbin } from 'assets/icons';
import SelectedFloatingFooter from 'components/Table/SelectedFloatingFooter';

interface IWorkersMappingTableFooter {
  selectedFlatRows: any[];
  toggleAllRowSelected: (value?: boolean) => void;
  handleImportWorkers: (value: any[]) => void;
  handleBulkMapUnmapEmployees: (value: any[], type: 'map' | 'unmap') => void;
  mappedUsers: any;
  isLoading: boolean;
  isBulkMapLoading: boolean;
  isBulkUnMapLoading: boolean;
  t: any;
}

const WorkersMappingTableFooter: React.FC<IWorkersMappingTableFooter> = ({
  selectedFlatRows,
  isLoading,
  t,
  mappedUsers,
  isBulkMapLoading,
  isBulkUnMapLoading,
  toggleAllRowSelected,
  handleImportWorkers,
  handleBulkMapUnmapEmployees,
}) => {
  const selectedIds: Array<any> = [];
  let showbulkUnmapButton = false;
  let showBulkMapButton = false;

  selectedFlatRows.forEach(row => {
    if (!selectedIds.includes(row.original.id)) {
      selectedIds.push(row.original.id);
    }

    if (row.original.selected_user) {
      showbulkUnmapButton = true;
    }

    if (mappedUsers && Object.keys(mappedUsers).includes(String(row.original.id))) {
      showBulkMapButton = true;
    }
  });

  return (
    <SelectedFloatingFooter selectedFlatRows={selectedFlatRows} toggleAllRowSelected={toggleAllRowSelected}>
      <Flex justifyContent="flex-end" sx={{ gap: '8px' }}>
        <Button isLoading={isLoading} variant="primary-ghost" onClick={() => handleImportWorkers(selectedIds)}>
          {t('integrations:importEmployees')}
        </Button>

        {showBulkMapButton ? (
          <Button
            isLoading={isBulkMapLoading}
            variant="solid"
            onClick={() => handleBulkMapUnmapEmployees(selectedFlatRows, 'map')}
          >
            {t('integrations:bulkMapEmployees')}
          </Button>
        ) : null}

        {showbulkUnmapButton ? (
          <Button
            isLoading={isBulkUnMapLoading}
            _hover={{ bg: 'rgba(255, 83, 83, 0.2)' }}
            _active={{ bg: 'rgba(255, 83, 83, 0.2)' }}
            bg="rgba(255, 83, 83, 0.1)"
            color="red"
            onClick={() => handleBulkMapUnmapEmployees(selectedFlatRows, 'unmap')}
            leftIcon={<Icon as={IconTrashbin} />}
          >
            {t('integrations:bulkUnmapEmployees')}
          </Button>
        ) : null}
      </Flex>
    </SelectedFloatingFooter>
  );
};

export default WorkersMappingTableFooter;
